<template>
  <div qaid="customization-suspension-calculator-notice" class="text-black mx-3 mb-2">
    <span>{{ $t('product.fdp.customizable.needHelpChoosing') }}</span>
    <a
      qaid="customization-suspension-calculator-link"
      class="underline"
      target="_blank"
      href="/suspension-calculator/"
      >{{ $t('product.fdp.customizable.needHelpChoosing.suspensionCalc') }}</a
    >
    <pdl-icon size="24" name="straighten" />
  </div>
</template>

<script>
import {PdlIcon} from '@pedal/pdl-icon';
export default {
  name: 'CustomizationSuspensionCalculator',
  components: {
    PdlIcon,
  },
};
</script>
